import React, { useState } from "react";
import { Link } from "react-router-dom";
// import { Search } from "lucide-react";  
// import { products } from "../Data/searchproduct";
import { Phone } from "lucide-react";        
import SearchProducts from "../Pages/SearchProduct";

import "../style/Header.css";



const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  
  
// hamburger  
  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };




  
  //     const [showSearch, setShowSearch] = useState(false);
  //     const [searchQuery, setSearchQuery] = useState("");
  
  //     const filteredProducts = products.filter((p) =>
  //   p.name.toLowerCase().includes(searchQuery.toLowerCase())
  // );





  return (
    <header>
      <nav className="navbar">
        {/* Logo */}
        <div className="logo">
          <Link to="/">
            <img src="/logo/AOKLOGO1.png" alt="logo" width="160px" height="65px" />
          </Link>
        </div>

        {/* Hamburger */}
        <div className="hamburger" onClick={toggleMenu}>
          ☰
        </div>

        {/* Nav Links */}
        <ul className={`nav-links ${menuOpen ? "active" : ""}`}>
          <li>
            <Link to="/"><strong>HOME</strong></Link>
          </li>

          {/* PRODUCT */}
          <li className="dropdown" >
            <Link to="/product"><strong>PRODUCTS</strong></Link>
            <ul className="dropdown-menu">

              {/* Tubular Motor */} 
              <li className="dropdown" style={{width:"220px" }}>
                <Link to="/product/tubular" style={{ fontSize: "17px" }}>Tubular Motors</Link>
                <ul className="dropdown-menu">
                  <li className="dropdown-width" style={{marginLeft: "10px", fontSize: "16px" }}><span><strong>AC Tubular Motor</strong></span></li>
                  <li style={{ fontSize: "13px" }}>
                    <Link to="/product/tubular/ac/am28/AM28"> AM28 AC Tubular Motor</Link>
                  </li>
                  <li style={{ fontSize: "13px" }}>
                    <Link to="/product/tubular/ac/AM35"> AM35 AC Tubular Motor</Link>
                  </li>
                  <li style={{ fontSize: "13px" }}>
                    <Link to="/product/tubular/ac/am45"> AM45 AC Tubular Motor</Link>
                  </li>
                  <li style={{ fontSize: "13px" }}>
                    <Link to="/product/tubular/ac/am60"> AM60 AC Tubular Motor</Link>
                  </li>

                  <li className="dropdown-width" style={{marginLeft: "10px", fontSize: "16px" }}><span><strong>DC Tubular Motor</strong></span></li>
                  <li style={{ fontSize: "13px" }}>
                    <Link to="/product/tubular/dc/am25/AM25-1-2-30-es-e"> AM25 DC Tubular Motor</Link>
                  </li>
                  <li style={{ fontSize: "13px" }}>
                    <Link to="/product/tubular/dc/am28/AM28-1-8-30-es-e"> AM28 DC Tubular Motor</Link>
                  </li>
                </ul>
              </li>
              <li className="dropdown">
                <Link to="/product/curtain" style={{ fontSize: "17px" }}>Curtain Motors</Link>
              </li>
              <li className="dropdown" >
                <Link to="/product/venetian" style={{ fontSize: "17px" }}>Venetian Blinds Motor</Link>
              </li>
              <li className="dropdown">
                <Link to="/product/control" style={{ fontSize: "17px" }}>Control Systems</Link>
                <ul className="dropdown-menu">
                  <li style={{ fontSize: "13px" }}>
                    <Link to="/product/control/RemoteController">REMOTE CONTROLLERS</Link>
                  </li>
                  <li style={{ fontSize: "13px" }}>
                    <Link to="/product/control/receiver">RADIO RECEIVER</Link>
                  </li>
                </ul>
              </li>
            </ul>
          </li>

          {/* SOLUTION */}
          <li className="dropdown"  >
            <Link to="/solution"><strong>SOLUTIONS</strong></Link>
            <ul className="dropdown-menu" style={{width:"250px"}}>
              <li><Link to="/solution/indoor" style={{ fontSize: "17px" }}>Indoor Shading Solutions</Link></li>
              <li><Link to="/solution/outdoor" style={{ fontSize: "17px" }}>Outdoor Shading Solutions</Link></li>
            </ul>
          </li>

          {/* SUPPORT */}
          <li className="dropdown">
            <Link to="#"><strong>SUPPORTS</strong></Link>
            <ul className="dropdown-menu" style={{width:"200px"}}>
              <li><Link to="/contact" style={{ fontSize: "17px" }}>Contact Us</Link></li>
              <li><Link to="/faqs" style={{ fontSize: "17px" }}>FAQs</Link></li>
              <li><Link to="/local" style={{ fontSize: "17px" }}>Local Distributor</Link></li>
              <li><Link to="/videocentre" style={{ fontSize: "17px" }}>Video Centre</Link></li>
            </ul>
          </li>

          {/* EXPLORE */}
          <li className="dropdown">
            <Link to="#"><strong>EXPLORE A-OK</strong></Link>
            <ul className="dropdown-menu" style={{width:"220px"}}>
              <li><Link to="/about" style={{ fontSize: "17px" }}>About Us</Link></li>
              <li><Link to="/controltechniques" style={{ fontSize: "17px" }}>Control And Technologies</Link></li>
              <li><Link to="/certificate" style={{ fontSize: "17px" }}>Certificates And Honor</Link></li>
              <li><Link to="/career" style={{ fontSize: "17px" }}>Career</Link></li>
            </ul>
          </li>

          {/* SEARCH BOX
          <li>
            <div className="search-box">
              <input
                type="text"
                placeholder="Search product..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
              <button onClick={searchProduct}>🔍</button>
            </div>
          </li> */}

           {/* SEARCH ICON */}
         {/* <li>
          <button
            onClick={() => setShowSearch(!showSearch)}
            className="search-btn p-3 hover:text-yellow-400"
          >
            <Search size={22} />
          </button>
         </li> */}


              <SearchProducts />


            <li>
              <Link to="/Contact">
              <button className="get-btn">
                <Phone className="phone-icon" /> 
                  GET IN TOUCH
              </button>
            </Link>
            </li>
          
      </ul>
   
          
         

        
      </nav>
    </header>
  );
};

export default Header;
